import { render, staticRenderFns } from "./zendesk-button.component.vue?vue&type=template&id=6e2af126"
import script from "./zendesk-button.component.vue?vue&type=script&lang=js"
export * from "./zendesk-button.component.vue?vue&type=script&lang=js"
import style0 from "./zendesk-button.component.vue?vue&type=style&index=0&id=6e2af126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports